<script lang="ts" setup>
import type { ResponseResult } from '~kui/types/formResult';

import { defineField, defineFormConfig } from '~kui/components/KUI/Core/Form/util/form';
import { useI18n } from 'vue-i18n';
import { z } from 'zod';

interface Props {
  result?: ResponseResult | null;
  loading?: boolean;
  marketingOptInDefault?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  result: null,
  loading: false,
  marketingOptInDefault: false,
});

const emit = defineEmits<{
  submit: [payload: { optIn: boolean }];
}>();

const { t } = useI18n();

// Same label and wording version as the sign-up box. Read once: the student answers the box as first shown.
const formConfig = defineFormConfig(
  {
    optIn: defineField({
      type: 'checkbox',
      options: {
        label: t('unified.onboarding.marketingOptIn'),
        dataTestId: 'onboarding-marketing-opt-in',
      },
      initialValue: props.marketingOptInDefault,
      schema: z.boolean(),
    }),
  },
  t('general.continue'),
);

const handleSubmit = (values: { optIn?: boolean }) => {
  emit('submit', { optIn: values.optIn ?? false });
};
</script>

<template>
  <div data-testid="onboarding-marketing-step">
    <KUICoreForm
      :form-config="formConfig"
      allow-clean-submit
      :form-result="result"
      :loading="loading"
      @submit="handleSubmit"
    />
  </div>
</template>
